<div class="bc-workitem-text-chat-list">
  <div class="bc-sidenav-title-wrapper">
    <h2 class="bc-sidenav-title">
      <svg-icon icon="messaging"></svg-icon>
      <span class="bc-sidenav-title-label" translate="{{ isHybrid ? 'bcWorkitemTextChatList.dxTitleTextChats' : 'bcWorkitemTextChatList.titleTextChats'}}"></span>
      <span> ({{ getTextChatWorkitemCount() }}) </span>
    </h2>
  </div>

  <div *ngIf="isIdleStateEnabled" class="bc-sidenav-title-wrapper">
    <h3 class="bc-sidenav-title">
      <span class="bc-sidenav-subtitle-label" translate="bcWorkitemTextChatList.titleOpenConversations"></span>
      <span> ({{ getTextChatActiveWorkitemCount() }}) </span>
    </h3>
  </div>
  <workitem-text-chat-list-content [textChatWorkItemList]="textChatActiveWorkItemList" [visitorLanguageCode]="visitorLanguageCode"></workitem-text-chat-list-content>

  <div *ngIf="isIdleStateEnabled" class="bc-sidenav-title-wrapper">
    <h3 class="bc-sidenav-title">
      <span class="bc-sidenav-subtitle-label" translate="bcWorkitemTextChatList.titlePendingConversations"></span>
      <span> ({{ getTextChatPendingWorkitemCount() }}) </span>
    </h3>
  </div>
  <workitem-text-chat-list-content *ngIf="isIdleStateEnabled" [textChatWorkItemList]="textChatPendingWorkItemList" [visitorLanguageCode]="visitorLanguageCode"></workitem-text-chat-list-content>
</div>
